module.exports = __webpack_public_path__ + "static/img/13.a12b1fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/13.jpg
// module id = NZEx
// module chunks = 1